module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/event-06-5464b6f1d5ab0d1217bc422565229af8.jpg";